import type { PortableTextBlock } from 'next-sanity';

/**
 * Removes duplicate marks from portable text spans to prevent nested links
 */
export const cleanPortableTextMarks = (
  content: PortableTextBlock[] | null
): PortableTextBlock[] | null => {
  if (!content) return null;

  return content.map((block) => {
    if (block._type !== 'block' || !block.children) {
      return block;
    }

    return {
      ...block,
      children: block.children.map((child) => {
        if (child._type === 'span' && Array.isArray(child.marks)) {
          return {
            ...child,
            marks: [...new Set(child.marks)], // Remove duplicates
          };
        }
        return child;
      }),
    };
  });
};
